import React, { useMemo, useRef, useCallback } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { sanitizeTicketDescriptionHtml } from '../utils/richTextUtils';

const EDITOR_FORMATS = ['bold', 'italic', 'list', 'link'];

const EDITOR_MODULES = {
  toolbar: [
    ['bold', 'italic'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
    ['clean'],
  ],
  clipboard: { matchVisual: false },
};

/**
 * Ticket description editor — limited toolbar; output is allowlist-sanitised HTML.
 */
export function RichTextEditor({ id, value, onChange, placeholder, disabled = false }) {
  const quillRef = useRef(null);

  const modules = useMemo(() => EDITOR_MODULES, []);

  const handleChange = useCallback(
    (content, _delta, _source, editor) => {
      const raw = editor.getLength() <= 1 ? '' : content;
      onChange(sanitizeTicketDescriptionHtml(raw));
    },
    [onChange]
  );

  return (
    <div
      id={id}
      className={`ticket-rich-text-editor rounded-md border border-gray-300 bg-white focus-within:border-blue-500 focus-within:ring-1 focus-within:ring-blue-500 ${
        disabled ? 'opacity-60 pointer-events-none' : ''
      }`}
    >
      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={value || ''}
        onChange={handleChange}
        modules={modules}
        formats={EDITOR_FORMATS}
        placeholder={placeholder}
        readOnly={disabled}
      />
    </div>
  );
}
